import { List, Map } from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { AutoSizer, Column, Table } from 'react-virtualized';
import { ElementActions } from '../../../actions/element';
import { ModalActions } from '../../../actions/modal';
import RightColumn from '../../../components/RightColumn';
import '../../../styles/ElementsByType.css';
// import SortAndFilter from './SortAndFilter';
import '../../../styles/ReactVirtualized.css';
import ElementCell from './ElementCell';
import ElementsByTypeToolbar from './ElementsByTypeToolbar';
import {hashHistory} from "react-router";


// class ElementTypeHeader extends Component {
//   static propTypes = {
//     elementType: PropTypes.instanceOf(Map),
//     taskTypeBool: PropTypes.bool,
//   };

//   render() {
//     const { elementType, taskTypeBool } = this.props;

//     const header = taskTypeBool
//       ? 'Tasks and Milestones'
//       : elementType.get('type');

//     return <span>{`${header} List `}</span>;
//   }
// }

class ElementsByType extends Component {
  static propTypes = {
    currentProjectId: PropTypes.string,
    filteredElements: PropTypes.instanceOf(List),
    elementTypeId: PropTypes.string,
    elementType: PropTypes.instanceOf(Map),
    elementTypes: PropTypes.instanceOf(Map),
    elements: PropTypes.instanceOf(Map),
    dispatch: PropTypes.func,
    currentUser: PropTypes.instanceOf(Map),
    relationshipsMapping: PropTypes.instanceOf(Map),
    taskTypeId: PropTypes.string,
    workBreakdownStructure: PropTypes.instanceOf(List),
    setSortByCallback: PropTypes.func,
    setSortOrFilterCallback: PropTypes.func,
    flatList: PropTypes.object,
    onElementSelected: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      currentElement: null,
      selectedElements: List(),
      showRightPanel: false,
      newIds: [],
    };

    this.handleCopy = this.handleCopy.bind(this);
  }

  componentDidMount() {
    const hash = hashHistory.getCurrentLocation().pathname;
    const selectedElementId = hash.split("selected-element=")[1] || null
    if (selectedElementId){
      this.handleChangeSelectedElements(selectedElementId, true);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.selectedElements.size === 1){
      this.props.onElementSelected(this.state.currentElement);
    }else{
      this.props.onElementSelected(null);
    }
  }

  toggleRightPanel = () => {
    if (!this.state.showRightPanel && this.state.selectedElements.size > 0) {
      this.setState({ showRightPanel: true });
    }
  };

  handleRightPanelClose = () => {
    this.setState({
      showRightPanel: false,
      selectedElements: List(),
    });
  };

  determineSelectedElements = (checked, elementId, selectedElements) => {
    const { elements, taskTypeBool } = this.props;
    const sameElementType =
      checked && selectedElements.size !== 0 && taskTypeBool
        ? elements.getIn([selectedElements.get(0), 'type_id']) ===
          elements.getIn([elementId, 'type_id'])
        : true;
    let newSelectedElements;

    if (checked) {
      newSelectedElements = sameElementType
        ? selectedElements.push(elementId)
        : selectedElements;
    } else {
      newSelectedElements = selectedElements.delete(
        selectedElements.indexOf(elementId),
      );
    }

    return {
      newSelectedElements,
      sameElementType,
    };
  };

  determineNewCurrentElement = (
    checked,
    newSelectedElements,
    elementId,
    showRightPanel,
    sameElementType,
  ) => {
    const { elements } = this.props;

    if (checked && newSelectedElements.size === 1) {
      return {
        element: sameElementType
          ? elements.get(elementId)
          : elements.get(newSelectedElements.get(0)),
        rightPanel: true,
      };
    } else if (newSelectedElements.size === 1) {
      const lastElementId = newSelectedElements.get(0);
      return {
        element: elements.get(lastElementId),
        rightPanel: showRightPanel,
      };
    } else if (newSelectedElements.size === 0) {
      return {
        element: null,
        rightPanel: false,
      };
    } else {
      return {
        element: null,
        rightPanel: showRightPanel,
      };
    }
  };

  handleChangeSelectedElements = (elementId, checked) => {
    const { selectedElements, showRightPanel } = this.state;

    const arrayData = this.determineSelectedElements(
      checked,
      elementId,
      selectedElements,
    );
    const elementData = this.determineNewCurrentElement(
      checked,
      arrayData.newSelectedElements,
      elementId,
      showRightPanel,
      arrayData.sameElementType,
    );

    this.setState({
      selectedElements: arrayData.newSelectedElements,
      showRightPanel: elementData.rightPanel,
      currentElement: elementData.element,
    });
  };

  confirmDelete(elementId) {
    const { dispatch, elements } = this.props;
    const element = elements.get(elementId);
    const name = element.get('name');

    dispatch(
      ModalActions.toggleModal({
        name: 'DeleteConfirmationModal',
        options: {
          deleteType: 'element',
          handleDelete: ::this.handleDelete.bind(this, element),
          name,
        },
      }),
    );
  }

  callback = element => {
    const elementId = element.get('id');

    this.setState({
      currentElement: element,
      selectedElements: List().push(elementId),
      showRightPanel: true,
    });
  };

  setSortBy = sortBy => {
    const { setSortByCallback } = this.props;

    setSortByCallback(sortBy);
  };

  setSortOrFilterType = (entity, entityType, add) => {
    const { setSortOrFilterCallback } = this.props;

    setSortOrFilterCallback(entity, entityType, add);
  };

  handleDelete = () => {
    const { dispatch, currentProjectId } = this.props;
    const { selectedElements } = this.state;
    if (selectedElements.size) {
      dispatch(
        ElementActions.deleteElementMulti(currentProjectId, selectedElements),
      );
      const newSelectedElements = selectedElements.filter(
        element => selectedElements.indexOf(element) === -1,
      );
      this.setState({
        selectedElements: newSelectedElements,
        showRightPanel: newSelectedElements.size > 0,
      });
    }
  };

  confirmDelete = () => {
    const { dispatch } = this.props;
    dispatch(
      ModalActions.toggleModal({
        name: 'DeleteConfirmationModal',
        options: {
          deleteType: 'multiElements',
          handleDelete: this.handleDelete,
        },
      }),
    );
  };

  async handleCopy() {
    const { dispatch, currentProjectId } = this.props;
    const { selectedElements } = this.state;
    if (selectedElements.size) {
      const response = await dispatch(
        ElementActions.copyElements(currentProjectId, selectedElements),
      );
      const newIds = response.result.map(t => t.id);
      this.setState({ newIds, selectedElements: List(newIds) });
    }
  }

  determineColumnWidth(selectedElements, currentElement) {
    const { showRightPanel } = this.state;

    const rightPanelDisplay =
      (selectedElements.size > 0 ||
        (currentElement && currentElement.size > 0)) &&
      showRightPanel;

    return {
      col1: rightPanelDisplay ? 'col-md-8' : 'col-md-12',
      col2: rightPanelDisplay ? 'col-md-4' : 'col-md-0',
    };
  }

  determineRightbar(selectedElements, currentElement, columns) {
    const { showRightPanel } = this.state;
    const { elements, elementTypes } = this.props;

    if (showRightPanel) {
      const entityType = selectedElements.size > 1 ? 'multiEdit' : 'element';
      const callback = this.handleRightPanelClose;
      const entity =
        selectedElements.size > 1 ? selectedElements : currentElement;
      const elementType = elementTypes.get(
        elements.getIn([selectedElements.get(0), 'type_id']),
      );

      return (
        <RightColumn
          entity={entity}
          callback={callback}
          entityType={entityType}
          columnSize={columns.col2}
          options={{ elementType }}
          flexOverride
          leftBorder={true}
        />
      );
    }

    return <div />;
  }

  addTasksCallback = thing => {
    const { elements, elementType, dispatch } = this.props;

    const initialArrayOfOutputs = List().push({
      entity: elements.filter(a => a.get('name') === thing.get('title')),
      relationship_type: thing.get('type'),
    });

    const optionsObject = {
      elementTypeId: elementType.get('id'),
    };

    initialArrayOfOutputs.forEach(entity => {
      let relTypeTitle = entity.relationship_type;
      if (entity.relationship_type === 'Work Breakdown Structure') {
        relTypeTitle = 'WBS Element';
      }

      optionsObject[relTypeTitle] = entity.entity
        .keySeq()
        .toList()
        .first();
    });
    dispatch(
      ModalActions.toggleModal({
        name: 'CreateElementNewModal',
        options: optionsObject,
      }),
    );
  };

  getWbsElementId = thing => {
    const { elements, elementType } = this.props;

    const initialArrayOfOutputs = List().push({
      entity: elements.filter(a => a.get('name') === thing.get('title')),
      relationship_type: thing.get('type'),
    });

    const optionsObject = {
      elementTypeId: elementType.get('id'),
    };

    initialArrayOfOutputs.forEach(entity => {
      let relTypeTitle = entity.relationship_type;
      if (entity.relationship_type === 'Work Breakdown Structure') {
        relTypeTitle = 'WBS Element';
        optionsObject[relTypeTitle] = entity.entity
          .keySeq()
          .toList()
          .first();
      }
    });
    return optionsObject;
  };

  render() {
    const {
      currentProjectId,
      elementType,
      elements,
      // taskTypeId,
      flatList,
      // sortType,
      // workBreakdownStructure,
      // filterType,
      // sortBy,
      taskTypeBool,
      userMode,
    } = this.props;

    const { selectedElements, currentElement } = this.state;

    const selectedType = selectedElements.size ? elements.getIn([selectedElements.get(0), 'type'], null) : null;

    const columns = this.determineColumnWidth(selectedElements, currentElement);
    const rightBar = this.determineRightbar(
      selectedElements,
      currentElement,
      columns,
    );

    return (
      <div style={{ display: 'flex', flex: 1, flexDirection: 'row' }}>
        <div
          style={{
            display: 'flex',
            flex: 1,
            height: 'calc(100vh - 40px)',
            flexDirection: 'column',
            padding: '0 15px',
          }}
        >
          <h2 className="h2-margin">
            {/* <ElementTypeHeader
              elementType={elementType}
              currentProjectId={currentProjectId}
              taskTypeBool={taskTypeBool}
            /> */}
            <ElementsByTypeToolbar
              toggleRightPanel={this.toggleRightPanel}
              handleCopy={this.handleCopy}
              confirmDelete={this.confirmDelete}
            />
          </h2>
          {/*<SortAndFilter
            taskTypeId={taskTypeId}
            elementTypeId={elementType.get('id')}
            sortType={sortType}
            filterType={filterType}
            workBreakdownStructure={workBreakdownStructure}
            setSortOrFilterType={this.setSortOrFilterType}
            sortBy={sortBy}
            setSortBy={this.setSortBy}
          />*/}
          <div className="elements-list">
            <AutoSizer>
              {({ height, width }) => {
                return (
                  <Table
                    width={width}
                    height={height}
                    headerHeight={20}
                    rowHeight={30}
                    rowCount={flatList.rowCount}
                    rowGetter={({ index }) => flatList.flatList.get(index)}
                  >
                    <Column
                      dataKey="name"
                      width={300}
                      flexGrow={1}
                      cellRenderer={({ rowData, rowIndex }) => {
                        const rowElement = rowData.get('element') || rowData;
                        const options = this.getWbsElementId(rowElement);

                        return (
                          <ElementCell
                            rowIndex={rowIndex}
                            selectedTypeMatch={selectedType ? selectedType === rowData.getIn(['element', 'type_id'], true) : true}
                            currentRowData={rowElement}
                            elementTypeName={elementType.get('type')}
                            elementTypeId={elementType.get('id')}
                            modalOptions={options}
                            callback={this.callback}
                            addTasksCallback={this.addTasksCallback}
                            isSelected={
                              this.state.selectedElements.indexOf(
                                rowElement.get('id', '0'),
                              ) > -1
                            }
                            onChangeElementCheckbox={
                              this.handleChangeSelectedElements
                            }
                            isNew={
                              this.state.newIds.indexOf(
                                rowElement.get('id', '0'),
                              ) > -1
                            }
                            userMode={userMode}
                          />
                        );
                      }}
                    />
                  </Table>
                );
              }}
            </AutoSizer>
          </div>
        </div>
        {rightBar}
      </div>
    );
  }
}

export default ElementsByType;



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/ElementsByType/ElementsByType.js